// this file is automatically generated by git.version.ts script
export const versions = {version: '1.37.0', revision: '4c3d1ba5', branch: 'HEAD'};
